import { env } from '@/lib/env'
import type { createAppRouter } from '@/router'

import { createGoogleAnalytics } from './ga4'
import { createGoogleTagManager } from './gtm'

type AppRouter = ReturnType<typeof createAppRouter>

export function initializeAnalytics(router: Pick<AppRouter, 'subscribe'>) {
  // Choose one transport only. Never fall back on network failure: a late GTM load
  // could otherwise send the same page_view again through a second transport.
  const trackPageView = env.VITE_GTM_CONTAINER_ID
    ? createGoogleTagManager(
        env.VITE_GTM_CONTAINER_ID,
        env.VITE_GA4_MEASUREMENT_ID,
        env.VITE_GA4_DEBUG,
      )
    : createGoogleAnalytics(env.VITE_GA4_MEASUREMENT_ID, env.VITE_GA4_DEBUG)
  if (!trackPageView) return () => {}

  // Covers initial load, redirects and SPA/back/forward navigation, not preloads.
  return router.subscribe('onResolved', ({ toLocation }) => trackPageView(toLocation.pathname))
}
